// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.RentalManagerUserPropertyMultiEditWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { UserPropertyMultiEditRequestWebDto, UserPropertyMultiEditResponseWebDto } from '../..';

export const RentalManagerUserPropertyMultiEditWebApiHandler_multi_Path = '/api/web/v1/users/properties/multi';

/**
 * Update multiple fields of a listing
 */
export const RentalManagerUserPropertyMultiEditWebApiHandler_multi = (
  postData: UserPropertyMultiEditRequestWebDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyMultiEditRequestWebDto, UserPropertyMultiEditResponseWebDto>(
    {
      endpoint: RentalManagerUserPropertyMultiEditWebApiHandler_multi_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};
